import { useCallback, useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const POLLING_INTERVAL_MS = 60 * 1000;

interface ServiceWorkerUpdatesState {
  showUpdatePrompt: boolean;
  confirmUpdate: () => void;
  dismissUpdate: () => void;
}

export const useServiceWorkerUpdates = (): ServiceWorkerUpdatesState => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState<boolean>(false);

  const {
    offlineReady: [, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) {
        return;
      }
      setInterval(() => {
        registration.update();
      }, POLLING_INTERVAL_MS);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      setShowUpdatePrompt(true);
    }
  }, [needRefresh]);

  const confirmUpdate = useCallback((): void => {
    setShowUpdatePrompt(false);
    setNeedRefresh(false);
    setOfflineReady(false);
    updateServiceWorker(true);
  }, [setNeedRefresh, setOfflineReady, updateServiceWorker]);

  const dismissUpdate = useCallback((): void => {
    setShowUpdatePrompt(false);
    setNeedRefresh(false);
  }, [setNeedRefresh]);

  return {
    showUpdatePrompt,
    confirmUpdate,
    dismissUpdate,
  };
};

